<template>
  <div>
    <!-- 面包屑 -->
    <bread-crumb path='文章管理' subPath='来源点击量统计'></bread-crumb>
    <!-- 主体列表 -->
    <el-card>
      <el-row :gutter="20">
        <el-col :span="4">
          <el-select v-model="param.list_type" placeholder="请选择来源" @change="listTypeChange" filterable>
            <el-option :key="1" label="天" :value="1"></el-option>
            <el-option :key="2" label="月" :value="2"></el-option>
          </el-select>
        </el-col>
      </el-row>
    </el-card>
    <el-table :data="list" stripe border :cell-style="{ textAlign: 'center' }">
      <el-table-column prop="source_title" label="来源" align="center" width="200px;"></el-table-column>
      <el-table-column v-if="param.list_type === 2" label="月份" align="center">
        <template slot-scope="scope">
          {{scope.row.hit_month*1000 | monthFormat}}
        </template>
      </el-table-column>
      <el-table-column v-else label="日期" align="center">
        <template slot-scope="scope">
          {{scope.row.hit_date*1000 | dateFormat}}
        </template>
      </el-table-column>
      <el-table-column prop="hits" label="点击量" align="center"></el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="param.page"
      :page-sizes="[10, 20, 30, 40, 50]"
      :page-size="param.count"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>
  </div>
</template>

<script>
import BreadCrumb from '../BreadCrumb.vue'
export default {
  name: 'hankpick_source_hit_list',
  components: {
    'bread-crumb': BreadCrumb
  },
  data () {
    return {
      list: [],
      total: 0,
      pageTotal: 1,
      param: {
        list_type: 1,
        page: 1,
        count: 10
      }
    }
  },
  created () {
    this.getList()
  },
  methods: {
    async getList () {
      const res = await this.$http.get('/admin/handpick_source/list_hit', this.param)
      if (res.code === 0) {
        this.list = res.data.list
        this.total = res.data.total
        this.pageTotal = res.data.total_page
      } else {
        this.$message.error(res.msg)
      }
    },
    listTypeChange () {
      this.list = []
      this.param.page = 1
      this.getList()
    },
    handleSizeChange (size) {
      this.param.count = size
      this.getList()
    },
    handleCurrentChange (page) {
      this.param.page = page
      this.getList()
    }
  }
}
</script>

<style scoped>
</style>
